import { NISProfessionalDetails } from "../../api/services/nisParticipants/models";
import { isEmpty, isNotEmpty } from "../../helpers/utils";

export const isHRContactOther = (data: NISProfessionalDetails): boolean => {
  return isEmpty(data?.hrContact) && isNotEmpty(data?.otherHRContactName);
};

export const isClientEmployerOther = (
  data: NISProfessionalDetails,
): boolean => {
  return isEmpty(data?.employer) && isNotEmpty(data?.otherEmployer);
};
